import { StickerLabelVariant } from '@stitch-fix/mode-react';

import { ModeStickerLabelTheme } from '../types/definitions/vendor/graphql-schema.d';

export const themeMapping: Record<ModeStickerLabelTheme, StickerLabelVariant> =
  {
    DEFAULT_LIGHT: 'white',
    NAVY: 'navy',
    WHITE: 'white',
    CITRUS: 'citrus',
    MINT: 'mint',
    DEFAULT_INVERSE: 'navy',
  };
